/**
 * Final project for ONE cohort (M2). Server-authoritative view: the student sees
 * the published rubric + deadline + submission + grade; the manager designates,
 * publishes the rubric and sets the date. Gated by `academy.final_project`.
 */
import { createRoute } from "@tanstack/solid-router";
import { msg } from "@lingui/core/macro";
import { Trophy } from "@fleet/icons";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { FinalProjectView } from "@/features/academy/final-project/final-project-view";

function FinalProjectDetailPage() {
  const { t } = useI18n();
  const params = finalProjectDetailRoute.useParams();
  return (
    <PageContainer maxWidth="3xl">
      <PageHeader
        title={t(msg`Final project`)}
        description={t(msg`Your capstone: rubric, deadline and submission`)}
        icon={Trophy}
        backTo="/final-project"
      />
      <div class="mt-4">
        <FinalProjectView cohortId={params().cohortId} />
      </div>
    </PageContainer>
  );
}

export const finalProjectDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/final-project/$cohortId",
  component: withFeatureGate("academy.final_project", FinalProjectDetailPage),
});
